import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";

import { MENU } from "./menu";
import { MenuItem } from "./menu.model";
import { PermissionService } from "src/app/core/services/permision.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.scss"],
})

/**
 * Sidebar component
 *
 * The nav is a single flat list, so active state is handled entirely by
 * `routerLinkActive` — no MetisMenu / dropdown bookkeeping needed.
 */
export class SidebarComponent implements OnInit {
  @Input() isCondensed = false;
  @Output() mobileMenuButtonClicked = new EventEmitter();

  menuItems: MenuItem[] = MENU;

  constructor(public permission: PermissionService) {}

  ngOnInit() {
    document.body.classList.add("authentication-bg");

    // Side effect: signs the user out when the cached permission blob is gone.
    this.permission.hasPermission("read");
  }

  /**
   * Toggle the menu bar when having mobile screen
   */
  toggleMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }
}
